import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { Cluster } from 'pages/complementar/cluster/types';

export function useQueryCluster() {
    const requestListagem = useRequestListagem();
    const { page, limit, sort, filter } = useListagemContext();

    const requestOptions: RequestOptionsType = {
        url: '/gestao/clusterloja',
        sort: sort.length ? sort : [{ property: 'idClusterLoja', direction: 'DESC' }],
        nested: true,
        filter,
        page,
        limit,
    };

    return useQuery<RequestListagem<Cluster[]>>({
        queryKey: ['cluster', requestOptions],
        queryFn: () => requestListagem(requestOptions).then((res) => res.data),
    });
}
